import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import Loading from '../../components/loading'
import NavBar from '../../components/navbar'
import UserCard from '../../components/usercard'
import ResultsBox from '../../components/results/resultsBox'
import PrintButton from '../../components/printButton'
import DownloadPDFButton from '../../components/downloadPDFButton'
import BackButtonMobile from '../../components/backButtonMobile'
import Footer from '../../components/footer'
import { fetchLabResultsThunk, setErrorState, setSelectedLabResult } from '../../actions/api';

const InfoContent = (props) => {
    const { labResults, strings } = props;
    if (labResults === undefined || labResults === null) {
        return null;
    }
    let results = labResults[0].result;
    if (results === 'positive') {
        return <p>{strings.INFO_POSITIVE_CONTENT}</p>;
    } else if (results === null || results === undefined || results === '') {
        return null;
    } else {
        return <p>{strings.INFO_CONTENT}</p>;
    }
}

const SingleResultScreen = (props) => {
    const { labResults, dispatch, isError, isLoadingLogin, isLoadingLabResults, isLoggedIn,
        history, language, user, strings, deviceType } = props;

    const [sendLoginAlert, setSendLoginAlert] = useState(false);
    const [selectedResult, changeResult] = useState(!labResults || !labResults[0] ? null : labResults[0]);

    const onChange = (data) => {
        changeResult(data.value);
        dispatch(setSelectedLabResult(data.value));
    }

    if (!selectedResult && labResults && labResults[0]) {
        onChange({ value: labResults[0] });
    }

    useEffect(() => {
        if (!labResults) {
            dispatch(fetchLabResultsThunk())
                .catch(err => {
                    if (err !== null && err !== undefined) {
                        if (['ARE', 'ADE'].includes(err.code)) {
                            setSendLoginAlert(true);
                        } else if (['SIE', 'MIE', 'LREE', 'DAE', 'PVE'].includes(err.code)) {
                            dispatch(setErrorState(true, err.message, true));
                        } else {
                            history.push("/");
                        }
                    }
                });;
        }
    }, []);

    if (isError === true) {
        return <Redirect to="error" />
    }

    if (isLoggedIn !== true || sendLoginAlert) {
        return <Redirect to={{
            pathname: "/",
            state: { loginAlert: sendLoginAlert }
        }} />
    }

    if (isLoadingLogin === true || isLoadingLabResults === true) {
        return <Loading />
    }

    return (
        <div className="container-full">
            <NavBar isLoggedIn={isLoggedIn} language={language} />
            <div className="container topPadding">
                <BackButtonMobile />
                <div className="col" id="first">
                    <div className="row wBorder">
                        <div className="col-12 col-md-4 order-1 order-sm-1 order-md-2 ml-auto ml-md-auto noMargin sideBox">
                            {user == null ? null : <UserCard user={user} language={language} />}
                            <PrintButton />
                            <DownloadPDFButton isHidden={['Mobile', 'Tablet'].includes(deviceType)} history={history} />
                            <div class="alert alert-info hideMobile" role="alert">
                                <InfoContent labResults={labResults} strings={strings} />
                            </div>
                        </div>
                        <div>

                        </div>
                        {!selectedResult ? null : <ResultsBox selectedResult={selectedResult} onChange={onChange} labResults={labResults} />}
                    </div>
                    <div class="alert alert-info hideDT" role="alert">
                        <InfoContent labResults={labResults} strings={strings} />
                    </div>
                    <div class="disclaimer alert" role="alert">
                        <h6>{strings.DISCLAIMER_HEADER}</h6>
                        <p>{strings.DISCLAIMER_CONTENT}</p>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        isLoadingLabResults: state.api.isLoadingLabResults,
        isLoadingUsers: state.api.isLoadingUsers,
        user: state.api.user,
        labResults: state.api.labResults,
        strings: state.language.strings,
        language: state.language.language,
        isLoggedIn: state.auth.isLoggedIn,
        isFakeLoggedIn: state.auth.isFakeLoggedIn,
        isError: state.api.isError,
        deviceType: state.api.deviceType,
    }
}

const ConnectedTestResultsScreen = connect(
    mapStateToProps
)(SingleResultScreen);
export default ConnectedTestResultsScreen;
